export const EXECUTION_STATUS = {
  START: "start",
  IN_PROGRESS: "inprogress",
};
